import { DependencyList, useCallback, useContext, useEffect } from 'react';
import { EventEmitterRCContext } from './EventEmitterRC';
import { BaseEvents } from './EventEmitter';

const useEmit = <Events extends BaseEvents>() => {
  const em = useContext(EventEmitterRCContext);
  const emit = useCallback(
    <E extends keyof Events>(type: E, ...args: Events[E]) => {
      console.log('emitter emit: ', type, args);
      em.emit(type, ...(args as any));
    },
    [em]
  );
  return { emit } as const;
};

const useListener = <E extends keyof Events, Events extends BaseEvents>(
  type: E,
  listener: (...args: Events[E]) => void,
  deps: DependencyList = []
) => {
  const em = useContext(EventEmitterRCContext);
  useEffect(() => {
    //console.log('emitter add: ', type, listener);
    em.add(type, listener);
    return () => {
      //console.log('emitter remove: ', type, listener);
      em.remove(type, listener);
    };
  }, [em, listener, type, deps]);
};

export function useEventEmitter<Events extends BaseEvents>() {
  const { emit } = useEmit<Events>();
  const listener = useListener as <E extends keyof Events>(
    type: E,
    listener: (...args: Events[E]) => void,
    deps?: DependencyList
  ) => void;

  return {
    useListener: listener,
    emit
  } as const;
}
